<template>
  <div id="app">
    <div id="content">
      <h2 class="title">{{ $t("titles.teams") }}</h2>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex
            d-flex
            xs12
            sm6
            md4
            v-for="team in club.teams"
            v-bind:key="team.id"
          >
            <div
              v-bind:key="team.id"
              class="teams"
              v-on:click="redirect('team', team.id)"
            >
              <div class="data">
                <h6>{{ $t("params.category") }} {{ team.category.max_age }}</h6>
                <div class="item">
                  <span class="value">{{ team.players }}</span>
                  <span class="label">{{ $t("titles.players") }}</span>
                </div>
                <div class="item">
                  <span class="value">{{ team.staff }}</span>
                  <span class="label">{{ $t("titles.staff") }}</span>
                </div>
                <div class="item">
                  <span class="value">{{ team.acompanyants }}</span>
                  <span class="label">{{ $t("titles.acompanyants") }}</span>
                </div>
                <div class="item">
                  <span class="value">{{ team.responsables }}</span>
                  <span class="label">{{ $t("titles.responsables") }}</span>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "Teams",
  components: {},
  data() {
    return {
      user: {},
      club: {}
    };
  },
  created() {
    this.user = this.$store.getters["user/getUser"];
    var self = this;
    if (this.user.admin) {
      this.$store
        .dispatch("club/loadClub", { club_id: this.user.club_id })
        .then(function() {
          self.club = self.$store.getters["club/getClub"];
        });
      // if user is not admin, redirect to home
    } else {
      this.redirect("home");
    }
  },
  methods: {
    redirect(path, id) {
      id == "undefined"
        ? this.$router.push({ name: path })
        : this.$router.push({ name: path, params: { id: id } });
    }
  }
};
</script>

<style lang="scss" scoped>
#app {
  background-color: #fff;
  margin: 0;
  padding: 0;
  height: 100%;
}

.teams {
  background-color: #fff;
  color: $bg-color;
  border: 0px solid #ddd;
  border-radius: 3px;
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  transition: all 0.3s;

  &:hover {
    background-color: #f5f5f5;
  }

  .data {
    padding: 10px;
    overflow: hidden;

    h6 {
      text-align: left;
      margin-top: 0;
      border-bottom: 2px solid $complem-color;
      color: $complem-color !important;
      background: url("/img/team_comp.svg") no-repeat left 5px center;
      background-size: 20px;
      padding-left: 35px;
      text-transform: uppercase;
      font-size: 16px;
    }

    .item {
      width: 50%;
      padding: 5px;
      text-align: center;
      float: left;
      margin: 5px 0;

      .value {
        display: block;
        font-family: Roboto-Bold;
        font-size: 40px;
        text-align: center;
      }
      .label {
        display: block;
        text-align: center;
        margin-top: 5px;
        font-size: 12px;
      }
    }
  }
}
</style>
